import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";
import { api } from "../lib/api";
import Reveal from "../components/Reveal";

const BlogPost = () => {
  const { slug } = useParams();
  const { lang, t } = useLang();
  const [post, setPost] = useState(null);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    api.get(`/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => setPost(null));
    api.get("/blog").then(({ data }) => setRelated(data.filter((p) => p.slug !== slug).slice(0, 3))).catch(() => {});
  }, [slug]);

  if (!post) return <div style={{ minHeight: "100vh", padding: 120, color: "var(--warm-off-white)" }}>Loading…</div>;

  return (
    <div data-testid="blog-post-page">
      <article className="section-pad" style={{ paddingTop: "clamp(160px, 18vw, 220px)", maxWidth: 920, margin: "0 auto" }}>
        <Link to="/blog" data-testid="back-to-blog" className="font-mono link-underline" style={{ color: "var(--gold)", textDecoration: "none", letterSpacing: "0.15em", fontSize: "0.75rem", textTransform: "uppercase", display: "inline-flex", alignItems: "center", gap: 8, marginBottom: 32 }}>
          <ArrowLeft size={14} /> {t.blog.back}
        </Link>
        <div className="font-mono" style={{ fontSize: "0.75rem", letterSpacing: "0.18em", color: "var(--gold)", textTransform: "uppercase" }}>{post.category}</div>
        <h1 className="font-display" style={{ fontSize: "clamp(2.25rem, 6vw, 5rem)", fontWeight: 300, lineHeight: 1.05, color: "var(--warm-off-white)", marginTop: 16, letterSpacing: "-0.01em" }}>
          {lang === "tr" ? post.title_tr : post.title_en}
        </h1>
        <p style={{ color: "rgba(248,244,240,0.7)", lineHeight: 1.7, fontSize: "1.15rem", marginTop: 24, fontStyle: "italic" }}>
          {lang === "tr" ? post.excerpt_tr : post.excerpt_en}
        </p>
        {post.featured_image && (
          <div style={{ aspectRatio: "16/9", overflow: "hidden", marginTop: 48 }}>
            <img src={post.featured_image} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          </div>
        )}
        <div className="font-body" style={{ color: "rgba(248,244,240,0.82)", lineHeight: 1.9, fontSize: "1.1rem", marginTop: 48 }} dangerouslySetInnerHTML={{ __html: lang === "tr" ? post.content_tr : post.content_en }} />
      </article>

      {related.length > 0 && (
        <section className="section-pad" style={{ background: "var(--rich-black-light)", borderTop: "1px solid rgba(248,244,240,0.06)" }}>
          <h2 className="font-display" style={{ fontSize: "clamp(2rem, 4vw, 3.5rem)", fontWeight: 300, color: "var(--warm-off-white)", marginBottom: 48 }}>{t.blog.relatedTitle}</h2>
          <div className="grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 24 }}>
            {related.map((p, i) => (
              <Reveal key={p.id} delay={i * 80}>
                <Link to={`/blog/${p.slug}`} style={{ textDecoration: "none" }}>
                  <div style={{ overflow: "hidden", aspectRatio: "16/10" }}>
                    <img src={p.featured_image} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  </div>
                  <h3 className="font-display" style={{ fontSize: "1.35rem", color: "var(--warm-off-white)", marginTop: 16, fontWeight: 400 }}>{lang === "tr" ? p.title_tr : p.title_en}</h3>
                </Link>
              </Reveal>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default BlogPost;
